import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { Button, IconButton } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { FunctionComponent } from 'react';

import { PlacesQuery } from '../../../apollo/__generated__/graphql';
import { Tooltip } from '../../../components/Tooltip';
import { Layout } from '../../../navigation/components/Layout/Layout';
import { BedroomsDrawer } from './components/BedroomsDrawer/BedroomsDrawer';
import { CreatePlaceDrawer } from './components/CreatePlaceDrawer/CreatePlaceDrawer';
import { DeletePlaceDialog } from './components/DeletePlaceDialog/DeletePlaceDialog';
import { EditPlaceDrawer } from './components/EditPlaceDrawer/EditPlaceDrawer';
import { usePlaces } from './usePlaces';

export const Places: FunctionComponent = () => {
  const {
    places,
    onShowBedrooms,
    onCreate,
    loading,
    isCreatePlaceDrawerOpen,
    onCloseCreatePlaceDrawer,
    onEditPlace,
    onShowDeletePlaceDialog,
    bedroomsPlaceId,
    editingPlace,
    placeToDeleteId,
    onCloseDeletePlaceDialog,
    onDeletePlace,
    onCloseEditPlace,
    onCloseBedroomsDrawer,
  } = usePlaces();

  const columns: GridColDef<PlacesQuery['places'][number]>[] = [
    {
      field: 'name',
      headerName: 'Nom',
    },
    {
      field: 'address',
      headerName: 'Adresse',
    },
    {
      field: 'id',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <>
          <Tooltip title="Voir les chambres">
            <IconButton onClick={() => onShowBedrooms(params.row.id)}>
              <FormatListBulletedIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Modifier le lieu">
            <IconButton color="info" onClick={() => onEditPlace(params.row)}>
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Supprimer le lieu">
            <IconButton
              color="error"
              onClick={() => onShowDeletePlaceDialog(params.row.id)}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  return (
    <Layout title="Administration - Lieux" activeTab="adminPlaces">
      <Button onClick={onCreate} variant="outlined" sx={{ marginBottom: 1 }}>
        Créer un lieu
      </Button>
      <DataGrid
        rows={places}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
        }}
        loading={loading}
      />
      <CreatePlaceDrawer
        isOpen={isCreatePlaceDrawerOpen}
        onClose={onCloseCreatePlaceDrawer}
      />
      <BedroomsDrawer
        placeId={bedroomsPlaceId}
        onClose={onCloseBedroomsDrawer}
        isOpen={bedroomsPlaceId !== null}
      />
      {editingPlace ? (
        <EditPlaceDrawer
          place={editingPlace}
          isOpen={editingPlace !== null}
          onClose={onCloseEditPlace}
        />
      ) : null}
      <DeletePlaceDialog
        onCancel={onCloseDeletePlaceDialog}
        onDelete={onDeletePlace}
        open={placeToDeleteId !== null}
      />
    </Layout>
  );
};
